import {
  ButtonNextDriver,
  buttonNextDriverFactory,
} from '../internal/WixUiCoreComponents/components/CoreButtonNext/CoreButtonNext.uni.driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { TextButtonPriority } from './types';

export interface TextButtonDriver extends ButtonNextDriver {
  isMobile(): Promise<boolean>;
  hasPriority(priority: TextButtonPriority): Promise<boolean>;
}

export const textButtonDriverFactory = (base: UniDriver): TextButtonDriver => {
  return {
    ...buttonNextDriverFactory(base),
    isMobile: async () => (await base.attr('data-mobile')) === 'true',
    hasPriority: async (priority: TextButtonPriority) =>
      (await base.attr('data-priority')) === priority,
  };
};
